import { z } from "zod";

/**
 * EntregaPesquisaSatisfacaoSchema
 */

export const EntregaPesquisaSatisfacaoSchema = z.object({
  idEntregaPesquisa: z.number().positive(),
  status: z.coerce.number().default(0),
  idEntregaObraCliente: z.number().nullable().default(null),
  data: z.coerce.date().nullable().default(null),
  observacao: z.string().nullable().default(null),
  itens: z.array(z.object({
    idItemPesquisaEntregaObra: z.number(),
    descricao: z.string().nullable().default(null),
    nota: z.number().nullable().default(null),
  })),
});

/**
 * EntregaPesquisaSatisfacaoForm
 */

export type EntregaPesquisaSatisfacaoForm = z.infer<typeof EntregaPesquisaSatisfacaoSchema>;